(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefit-slider"] && !Shopify.designMode) return;
  try {
    
let swiperItems = document.querySelectorAll('.swiper-slide');
console.log(swiperItems.length);
  
    var swiper = new Swiper(".mySwiper", {
        loop: true,  
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
        }
    });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fassadendaemmung-klimapartner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var container = document.getElementById('klimapartner-section');
  if (!container) return;

  var nextBtn = container.querySelector('.klima-next-step');
  var prevBtn = container.querySelector('.klima-prev-step');
  var steps = container.querySelectorAll('.klima-form-step');

  if (!nextBtn || !prevBtn || steps.length < 2) return;

  function setStep(stepIndex) {
    steps.forEach(function (step, index) {
      if (index === stepIndex) {
        step.classList.add('klima-form-step--active');
      } else {
        step.classList.remove('klima-form-step--active');
      }
    });
  }

  setStep(0);

  nextBtn.addEventListener('click', function () {
    setStep(1);
  });

  prevBtn.addEventListener('click', function () {
    setStep(0);
  });
});

  } catch(e) { console.error(e); }
})();
})();
